module.exports = __webpack_public_path__ + "static/img/tab-service-center-v3.4923629.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tab-service-center-v3.png
// module id = t6Gt
// module chunks = 0